<template>
  <div
    class="tournament-panel"
    :class="{ mini: !localVisible }"
    data-t="tournament-panel"
    @click="toogleElement()"
  >
    <header class="tournament-header" data-t="title-category-tournament">
      <div class="tournament-icon">
        <img
          v-if="tournamentImage"
          width="16"
          height="16"
          :src="tournamentImage"
          alt="tournament image"
        />
        <StIcon
          v-else-if="tournamentIconName"
          :name="tournamentIconName"
          :size="16"
        />
        <StIcon v-else name="cup-solid" :size="16" />
      </div>
      <div class="text">
        <p data-t="title-category">{{ category?.name }}</p>
        <p data-t="title-tournament">{{ tournament.name }}</p>
      </div>
      <StCounter
        v-if="showCounter"
        size="xs"
        bg-color="orange"
        class="tournament-count"
        data-t="tournament-counter"
      >
        {{ liveCount }}
      </StCounter>
    </header>
    <StIcon
      data-t="tournament-icon-collapse"
      class="tournament-collapse"
      :name="collapseIconName"
      :size="16"
    />
  </div>
</template>

<script lang="ts" setup>
import type { CustomMenuItem } from 'markets-store/types'
import type { IconName } from '@st/ui/components/StIcon/types'

interface Props {
  tournament: CustomMenuItem
  category: CustomMenuItem
  live?: boolean
  liveCount: number
}

const props = withDefaults(defineProps<Props>(), {
  live: false,
})

const emit = defineEmits<{
  toogleTournament: []
}>()

const tournamentImage = computed(() => props.tournament.image)
const tournamentIconName = computed(() => {
  const countryCode = props.category?.countryCode
  return countryCode ? (`f-${countryCode.toLowerCase()}` as IconName) : null
})

const localVisible = ref(true)
const collapseIconName = computed(() =>
  localVisible.value ? 'chevron-top' : 'chevron-down',
)

const showCounter = computed(() => !localVisible.value && props.liveCount)

function toogleElement() {
  emit('toogleTournament')
  localVisible.value = !localVisible.value
}
</script>

<style>
:root {
  --tournament-panel-top: 48px;
}
</style>
<style scoped>
.tournament-collapse {
  cursor: pointer;
  color: var(--text-tertiary);

  &:hover {
    color: var(--text-primary);
  }
}

.tournament-panel {
  cursor: pointer;
  user-select: none;

  position: sticky;
  z-index: 4;

  /* stylelint-disable */
  top: var(--tournament-panel-top);
  /* stylelint-enable */

  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 32px;
  padding: var(--spacing-100);

  background-color: var(--background-secondary);
  border-radius: var(--border-radius-100);

  &.mini {
    margin-bottom: var(--spacing-150);
  }

  &:hover {
    background-color: var(--background-tertiary);

    .tournament-collapse {
      color: var(--text-primary);
    }
  }
}

.tournament-header {
  display: flex;
  align-items: center;
}

.text {
  display: flex;
  gap: var(--spacing-100);

  p {
    font: var(--desktop-text-xs-semibold);
    color: var(--text-primary);
  }
}

.tournament-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 16px;
  height: 16px;
  margin-right: var(--spacing-100);
}

.tournament-count {
  margin-left: var(--spacing-100);
}
</style>
